export enum AiModes {
   GENERAL = "general",
   DASHBOARD_SUPPORT = "dashboard_support",
}

export enum CartesiaSpeeds {
   Slowest = "slowest",
   Slow = "slow",
   Normal = "normal",
   Fast = "fast",
   Fastest = "fastest",
}

export enum CartesiaEmotions {
   Positivity = "positivity",
   Curiosity = "curiosity",
   Anger = "anger",
   Sadness = "sadness",
   Surprise = "surprise",
}

export enum CartesiaLevels {
   Lowest = "lowest",
   Low = "low",
   Medium = "medium",
   High = "high",
   Highest = "highest",
}

export enum PersonaStyles {
   Friendly = "friendly",
   Professional = "professional",
   Casual = "casual",
   Aggressive = "aggressive",
   Funny = "funny",
   Serious = "serious",
   Empathetic = "empathetic",
   Introverted = "introverted",
   Extroverted = "extroverted",
   Concise = "concise",
   Technical = "technical",
}

export enum CHANNEL_TYPE {
   CHAT = "chat",
   GPT = "gpt",
   SMS = "sms",
   WHATSAPP = "whats_app",
}
